import styled from '@emotion/styled'
import { FunctionComponent, useState } from 'react'
import { Colors } from '~/assets/style/colors'

const RangeInput = styled.input`
  accent-color: ${Colors.King};
`

type Props = {
  value: number
  min: number
  max: number
  step?: number
  onChange: (value: number) => void
  disabled?: boolean
}

export const Slider: FunctionComponent<Props> = ({ value, min, max, step = 1, onChange, disabled = false }) => {
  const [localValue, setLocalValue] = useState<number>(value)
  // Resync localValue when the `value` prop changes ("previous value" pattern —
  // adjusting state during render, as recommended by React).
  const [prevValue, setPrevValue] = useState<number>(value)
  if (value !== prevValue) {
    setPrevValue(value)
    setLocalValue(value)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Math.trunc(+e.target.value)
    setLocalValue(newValue)
    onChange(newValue)
  }

  return <RangeInput type="range" value={localValue} min={min} max={max} step={step} onClick={(e) => e.stopPropagation()} onChange={handleChange} disabled={disabled} />
}
